module.exports = __webpack_public_path__ + "RMR PKG & TRN Guía de Inscripcion.pdf";